import React from "react";
import NumberToPersianWord from "number_to_persian_word";


/**
 * @return {string}
 */
function GetPrice(price= 0, lang, postFix,isTabletOrMobile) {
    return (lang === "fa" ? NumberToPersianWord.convertEnToPe(`${(price / 10).toLocaleString()}`) : (price / 10).toLocaleString("en-US")) + " " + (isTabletOrMobile ? (lang === "fa" ? postFix : "T") : postFix);
}

export default GetPrice;